import { immerable } from 'immer';
import { Set } from 'immutable';

interface IMemberAccessEntity {
	id: string;
	memberUuid: string;
	isGroup: boolean;
	permissions: Set<string>;
}

const entityDefaults: IMemberAccessEntity = {
	id: '-1',
	memberUuid: '',
	isGroup: false,
	permissions: Set(),
};

export class MemberAccessEntity implements IMemberAccessEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public memberUuid = entityDefaults.memberUuid;
	public isGroup = entityDefaults.isGroup;
	public permissions = entityDefaults.permissions;

	public static build(
		params: Partial<IMemberAccessEntity> = {}
	): MemberAccessEntity {
		const instance = new MemberAccessEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.memberUuid = params.memberUuid ?? entityDefaults.memberUuid;
		instance.isGroup = params.isGroup ?? entityDefaults.isGroup;
		instance.permissions = params.permissions ?? entityDefaults.permissions;
		return instance;
	}
}
